// RECONSTRUCTED STUB (data loss recovery)
// Original file was untracked and accidentally deleted during W1-A4-UI scope-violation cleanup.
// Provides the locale-loader registry consumed by i18n.ts. Restored from grep against the
// importing module so that build compiles and lazy-loading of ko/en/ja JSON still works.

export const DEFAULT_LOCALE = 'ko' as const

export const SUPPORTED_LOCALE_CODES = ['ko', 'en', 'ja'] as const

export type SupportedLocaleCode = (typeof SUPPORTED_LOCALE_CODES)[number]

export const LOCALE_LOADERS: Record<
  SupportedLocaleCode,
  () => Promise<{ default: Record<string, unknown> }>
> = {
  ko: () => import('./ko.json'),
  en: () => import('./en.json'),
  ja: () => import('./ja.json'),
}
